// extracted by mini-css-extract-plugin
export default {"HeaderSection":"Contacts_HeaderSection__AZCNK","SupportPhone":"Contacts_SupportPhone__6g8oD","Email":"Contacts_Email__IVr34"};